import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 * NOTA: "actividad" se maneja como texto descriptivo (no como id de catálogo).
 * Si en tu backend realmente es un id numérico de catálogo, avísame para
 * volver a tiparlo como number y cambiar el input por un ng-select.
 */
export interface CapacitacionActividadRePayload {
  id_actividad: number;
  actividad: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface CapacitacionActividadRe {
  id?: number;
  id_actividad: number;
  actividad: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface CapacitacionActividadReResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CapacitacionActividadReService {
  private readonly apiUrl = `${environment.apiUrl}/api/capacitacion_actividadre`;

  constructor(private http: HttpClient) {}

  // Listar todas las actividades relacionadas
  getAll(): Observable<CapacitacionActividadRe[]> {
    return this.http.get<CapacitacionActividadRe[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<CapacitacionActividadRe> {
    return this.http.get<CapacitacionActividadRe>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Obtener todas las actividadre asociadas a una actividad principal (id_actividad)
  getByIdActividad(id_actividad: number): Observable<CapacitacionActividadRe[]> {
    return this.http.get<CapacitacionActividadRe[]>(`${this.apiUrl}/actividad/${id_actividad}`, { withCredentials: true });
  }

  // Crear nueva actividad relacionada
  create(payload: CapacitacionActividadRePayload): Observable<CapacitacionActividadReResponse> {
    return this.http.post<CapacitacionActividadReResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar actividad relacionada
  update(id: number, payload: Partial<CapacitacionActividadRePayload>): Observable<CapacitacionActividadReResponse> {
    return this.http.put<CapacitacionActividadReResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar actividad relacionada (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar actividad relacionada
  inactivar(id: number): Observable<CapacitacionActividadReResponse> {
    return this.http.put<CapacitacionActividadReResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar actividad relacionada
  activar(id: number): Observable<CapacitacionActividadReResponse> {
    return this.http.put<CapacitacionActividadReResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}